const chargerDetailsMap = {
  displayName: "Display Name",
  siteId: "Site ID",
  serialNumber: "Serial Number",
  status: "Status",
  sku: "SKU",
  partNumber: "Part Number",
  operatingVoltage: "Operating Voltage",
  ratedCurrent: "Rated Current",
  phaseCount: "Phase Count",
  firmwareVersion: "Firmware Version",
  fwUpdatedAt: "Firmware Updated At",
  wifiConfig: "WiFi Config",
  wifiConfigDetails: "WiFi Config",
  netConfigDetails: "Network Config",
  cellularSettings: "Cellular Settings",
  timezone: "Timezone",
  lastReportedAt: "Last Reported At",
  offlineAt: "Last Offline At",
  createdAt: "Created At",
  isConnected: "Connection",
  activeConnection: "Active Connection",
  commissioningStatus: "Commissioning Status",
  isRetired: "Is Retired",
  hoControl: "Enabled",
  dlbEnabled: "DLB Enabled",
  dlbSource: "DLB Source",
  warrantyStartDate: "Warranty Start Date",
  warrantyDueDate: "Warranty Due Date",
  warrantyPeriod: "Warranty Period (years)",
  modelName: "Model Name",
  vendorName: "Vendor",
  phaseMode: "Phase Mode",
  protocol: "Protocol",
  protocolVersion: "Protocol Version",
  country: "Country",
  isOffGrid: "Off-Grid",
  // isDeviceReady: "Device Ready",
};

const fieldGroups = [
  {
    title: "Device Information",
    keys: [
      "displayName",
      "serialNumber",
      "siteId",
      "sku",
      "partNumber",
      "firmwareVersion",
      "fwUpdatedAt",
      "modelName",
      "vendorName",
      "country",
      "isRetired",
      "status",
      "createdAt",
      "lastReportedAt",
      "offlineAt",
      "timezone",
    ],
  },
  {
    title: "Partner Integration",
    keys: ["hoControl"],
  },
  {
    title: "Connectivity & Configuration",
    keys: [
      "activeConnection",
      "protocol",
      "protocolVersion",
      "commissioningStatus",
      "dlbEnabled",
      "dlbSource",
      "wifiConfig",
      "wifiConfigDetails",
      "netConfigDetails",
      "cellularSettings",
      "isConnected",
      "isDeviceReady",
    ],
  },
  {
    title: "Electrical Specs",
    keys: ["operatingVoltage", "phaseCount", "phaseMode", "ratedCurrent", "isOffGrid"],
  },
  {
    title: "Warranty",
    keys: ["warrantyDueDate", "warrantyPeriod", "warrantyStartDate"],
  },
];

const GROUP_ICONS = {
  "Device Information": { emoji: "🔌", color: "orange" },
  "Partner Integration": { emoji: "🤝", color: "green" },
  "Connectivity & Configuration": { emoji: "📡", color: "blue" },
  "Electrical Specs": { emoji: "⚡", color: "purple" },
  Warranty: { emoji: "🛡", color: "yellow" },
};

export { chargerDetailsMap, fieldGroups, GROUP_ICONS };
